import React, { useRef, useState, useEffect } from "react";
import { BiPlus } from "react-icons/bi";
import ToastAlert from "../../../components/CommonSection/ToastAlert/ToastAlert";
import { useNavigate } from "react-router-dom";
import { getfeepaginglist, addupdatefees ,getaccountcharts,getfeedetailbyid} from "../../../components/CommonSection/apiresources";
import { GetCookie ,currentProfile} from "../../../components/CommonSection/Cookie/Session";
import { makeRequestWithSpinner } from "../../../Utilities/client";
import { useSpinnerContext } from "../../../Utilities/SpinnerContext";
import { ActionStatus,eFeeType,eFeeChargingTo,eFeeCaluclationType   } from "../../../Utilities/enum";
import { dynamicUrl } from "../../../Utilities/profileManagement";
import CustomModal from "../../input-components/Modal";
import TextBox from "../../input-components/textbox";
import { useFormik } from "formik";
import SelectBox from "../../input-components/selectBoxNew"
import SubNav from "../../../components/CommonSection/Header/subHeader";
import AntdTableExample from "../../input-components/dataTable";
import ToggleTabs from "../../input-components/toggleButtonTabs";
import { Switch } from "antd";
import ShowValue from "../../input-components/ShowValue";

const initialValues = {
    displayName: "",
    chargingTo: eFeeChargingTo.Property,
    account: "",
    feeType: eFeeType.EveryRentReceipt,
    calculationType: eFeeCaluclationType.Percentage,
    isActive: true
  };
  

const ListFees = () => {
    const [feesLists, setFeesLists] = useState([]);
    const [userId, setUserId] = useState("");
    const [agencyID, setAgencyId] = useState("");
    const [chartData, setChartData] = useState();
    const navigate = useNavigate();
    const ToastRef = useRef();
    const [propertyType, setPropertyType] = useState(null);
    const [searchText, setSearchText] = useState("");
    const [purpose, setPurpose] = useState("");
    const { showSpinner, hideSpinner } = useSpinnerContext();
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [searchValue, setSearchValues] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [openFees, setOpenFees] = useState(false);
    const [agencyUniqueID, setAgencyUniqueID] = useState(false);
    const [tenantFolioId, setTenantFolioId] = useState(null);
    const currentUser = currentProfile.get();
    const [tabValue, setTabValue] = useState(1);
    const [accArr,setAccArr] = useState([]);
        const [getDetails, setGetDetails] = useState(null);
    const [accountValue,setAccountValue]= useState(null)
    const [feesTypeVal,setFeesTypeVal]= useState(null);
    const [calculationType,setCalculationType] = useState(null);
    const [modalMode, setModalMode] = useState("view"); 
    const eFeeTypeOptions = [
        { label: "Every Rent Receipt", value: eFeeType.EveryRentReceipt },
        { label: "First Rent Receipt", value: eFeeType.FirstRentReceipt },
        { label: "Agreement Date - Renewed", value: eFeeType.AgreementDate },
        { label: "Every Owner Invoice Receipt", value: eFeeType.EveryOwnerInvoiceReceipt },
        { label: "Inspection-Completed Entry", value: eFeeType.InspectionCompletedEntry },
        { label: "Inspection-Completed Exit", value: eFeeType.InspectionCompletedExit },
        { label: "Inspection-Completed Routine", value: eFeeType.InspectionCompletedRoutine },
        { label: "Supplier Bill Created", value: eFeeType.SupplierBillCreated },
        { label: "Recurring", value: eFeeType.Recurring },
        { label: "Manual", value: eFeeType.Manual },
        { label: "Each Statement Period", value: eFeeType.EachStatementPeriod },
      ];
   
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const retrieveData = async () => {
            try {
                const userData = GetCookie("@UserData");
                if (userData) {
                    const parsedData = JSON.parse(userData);
                    setUserId(parsedData.userId);
                    setAgencyId(parsedData.agencyID);
                    PostApiWithSpinner(parsedData.agencyID,currentUser === 13 ? parsedData.tenantFolioId: null)
                    setTenantFolioId(parsedData.tenantFolioId)
                    setAgencyUniqueID(parsedData.agencyUniqueID)
                    getAccountList();
                }
            } catch (error) {
                console.error("Error retrieving data from AsyncStorage:", error);
            }
        };
        retrieveData();
    }, [userId, searchText, searchValue, purpose, propertyType]);

     const GetApi = (value) => {
            const baseUrl = getfeedetailbyid;
            const apiUrl = `${baseUrl}?Id=${value}`;
            makeRequestWithSpinner(showSpinner, hideSpinner, apiUrl, "get")
                .then((response) => {
                    if (response.status === ActionStatus.Successfull) {
                        setGetDetails(response.object);
                        setFieldValue ("displayName", response.object.name);
                        setFieldValue("chargingTo", response.object.chargingTo);
                        setFieldValue("account", response.object.account);
                        setFieldValue("feeType", response.object.feeType);
                        setFieldValue("calculationType", response.object.calculationType);
                        setFieldValue("isActive", response.object.isActive);
                        setTabValue(response.object.chargingTo);
                        setAccountValue(response.object.account);
                        setFeesTypeVal(response.object.feeType);
                        setCalculationType(response.object.calculationType)
                    } else {
                        ToastRef.current.notify(["error", response.data.message]);
    
                    }
                })
                .catch((error) => {
                    handleparentsuccess(["error", error]);
                });
        };

      const getAccountList = () => {
                const baseUrl = getaccountcharts + "?type=0";
                makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "get")
                    .then((response) => {
                        if (response.status === ActionStatus.Successfull) {
                            const accArr = response.object.map(item => ({
                                label: item.text,
                                value: item.value
                            }));
                            setAccArr(accArr)
                        } else {
                            alert(`Message: ${response.message}`);
                        }
                    })
                    .catch((error) => {
                        console.error("Error:", error);
                    });
            };

            console.log(accArr)
    const PostApiWithSpinner = (agencyID,tenantid) => {
        const baseUrl = getfeepaginglist;
        let data = {
            AgencyId: agencyID,
        };
        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", data)
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    const feesData = response.list || [];
                    let feesList = feesData.map((fees) => ({
                        DisplayName: fees.name,
                        Charging: fees.sChargingTo,
                        Type: fees.sCalculationType,
                        Value: '-',
                        Notes: fees.notes,
                        Account: fees.accountName,
                        Status: fees.isActive ? "Yes" : "No",
                        id:fees.id
                    }));
                    setFeesLists(feesList);
                    setTotalPages(response.totalCount)
                    setChartData(response.object);
                } else {
                    alert(`Message: ${response.message}`);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

   
    const handleRowClick = (event, rowData) => {
        setModalMode("view");
        GetApi(rowData.id);
        setOpenFees(true)
    };


    const handlePageChange = (event, pageNumber) => {
        PostApiWithSpinner(event.page + 1, event.rows)
        setCurrentPage(pageNumber);
        setFirst(event.first);
        setRows(event.rows);
    };

    const handleAddFees = () => {
        setModalMode("add");
        setOpenFees(true);
        setFieldValue("displayName", "");
        setFieldValue("chargingTo", eFeeChargingTo.Property);
        setFieldValue("account", "");
        setFieldValue("feeType", eFeeType.EveryRentReceipt);
        setFieldValue("calculationType", eFeeCaluclationType.Percentage);
        setFieldValue("isActive", true);
        setTabValue(eFeeChargingTo.Property);
        setAccountValue("");
        setFeesTypeVal(eFeeType.EveryRentReceipt);
        setCalculationType(eFeeCaluclationType.Percentage)
    }

    const closeFees = () => {
        setOpenFees(false);
    }

    const {
        errors,
        values,
        touched,
        handleBlur,
        handleChange,
        handleSubmit,
        setValues,
        setFieldValue,
    } = useFormik({
        initialValues,
        onSubmit: (values) => {
            handleFinalInspection(values);
        },
    });


    const handleFinalInspection = () => {
        const finalData = {
          Id: modalMode === "edit" ? getDetails?.id : 0,
          Name: values.displayName,
          ChargingTo: values.chargingTo,
          Account: values.account,
          FeeType: values.feeType,
          CalculationType: values.calculationType,
          IsActive: values.isActive,
          AgencyId: parseInt(agencyID),
        };
      
        if (!values.displayName) {
          ToastRef.current.notify(["error", "Display name is required"]);
          return;
        }
      
        const url = addupdatefees;
        makeRequestWithSpinner(showSpinner, hideSpinner, url, "post", finalData)
          .then((returnData) => {
            if (returnData.status === ActionStatus.Successfull) {
              ToastRef.current.notify(["success", returnData.message]);
              setOpenFees(false);
              PostApiWithSpinner(agencyID, currentUser === 13 ? tenantFolioId : null);
            } else {
              ToastRef.current.notify(["error", returnData.message]);
            }
          })
          .catch((error) => {
            ToastRef.current.notify(["error", error.message]);
          });
      };
      

    const tabs = [
        { label: 'Property', value: eFeeChargingTo.Property },
        { label: 'Owner', value: eFeeChargingTo.Owner },
        ];

        const tabs1 = [
            { label: 'Percentage', value: eFeeCaluclationType.Percentage },
            { label: 'Fixed Amount', value: eFeeCaluclationType.FixedAmount },
            ];

            const actions = [
                { icon: "/assets/images/editing.svg", onClick: (e, data) => handleEdit(e, data) },
            ]

            const handleEdit = (e,data) => {
                e.stopPropagation();
                e.preventDefault();
                setOpenFees(true);
                setModalMode("edit");
                GetApi(data.id);
            }
    return (
        <div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 changedateantdstyle">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 daily-date-style">
                    <SubNav
                        title={"Fees"}
                        actionButton={false}
                        extraData={true}
                        goback={false}
                        extraContent={<div className="property-details-buttons">
                            <div>
                                <button
                                    className="Add-Property-button"
                                    onClick={handleAddFees}
                                    style={{ width: "175px" }}
                                >
                                    <div className="text-parent">
                                        <BiPlus style={{ width: "25px", height: "25px" }} />
                                        <div className="text7" style={{ fontSize: "14px" }}>
                                            Add Fees
                                        </div>
                                    </div>
                                </button>
                            </div>
                        </div>}

                    />
                    <div className="material-work-desk-new bg-white m-3">
                        <ToastAlert ref={ToastRef} />
                          
                        <AntdTableExample
                            label="List Fees"
                            dataSource={feesLists}
                            globalSearch
                            hideCol={"id"}
                            onPageChange={handlePageChange}
                            currentPage={currentPage}
                            totalRows={rows}
                            totalRecords={totalPages}
                            onRowClick={handleRowClick}
                            actions={actions}
                        />

                        <CustomModal
                            title={modalMode === "edit" ? "Update Fees" : modalMode === "view" ? "View Fees" :"New Fees"}
                            width={650}
                            closable={closeFees}
                            visible={openFees}
                            onCancel={closeFees}
                            modalData={
                                <div  style={{  marginLeft: "10px" }}>
                                  {modalMode === "view" && (
                                    <div className="contacts-group">
                                        <ShowValue Label='Display name'  setData={getDetails?.name} />
                                        <ShowValue Label='Who are you charging'  setData={getDetails?.sChargingTo} />
                                        <ShowValue Label='Account' setData={getDetails?.accountName} />
                                        <ShowValue Label='Fee type' setData={getDetails?.sFeeType} />
                                        <ShowValue Label='Calculation' setData={getDetails?.sCalculationType} />
                                        <ShowValue Label='Active' setData={getDetails?.isActive ? "Yes" : "No"} />
                                    </div>)}
                                    {(modalMode === "add" || modalMode === "edit") && (
                                    <>
                                    <TextBox
                                        colVal={12}
                                        label="Display name"
                                        isMandatory
                                        name="displayName"
                                        placeholder="Fee Name"
                                        value={values.displayName}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={errors.displayName}
                                        touched={touched.displayName}
                                    />
                                    <div className="col-lg-6">
                                    <label className="s1">Who are you charging</label>
                                    <ToggleTabs
                                            tabs={tabs}
                                            onTabChange={(val) => {
                                                setFieldValue("chargingTo", val);
                                                setTabValue(val);
                                            }}
                                            externalTabValue={tabValue}
                                        />
                                       
                                    </div>
                                    <SelectBox
                                        colVal={12}
                                        label="Account"
                                        name="account"
                                        options={accArr}
                                        value={accountValue?.toString()}
                                        onChange={(val) => {
                                            setFieldValue("account", val.value);
                                            setAccountValue(val.value);
                                        }}
                                    />


                                    <SelectBox
                                        colVal={12}
                                        label="Fee type"
                                        name="feeType"
                                        options={eFeeTypeOptions}
                                        value={feesTypeVal}
                                        onChange={(val) => {
                                            setFieldValue("feeType", val.value);
                                            setFeesTypeVal(val.value);
                                        }}
                                    />


                                      <div className="col-lg-6 mt-2">
                                      <label className="s1">Calcultion</label>
                                      <ToggleTabs
                                            tabs={tabs1}
                                            onTabChange={(val) => {
                                                setFieldValue("calculationType", val);
                                                setCalculationType(val);
                                            }}
                                            externalTabValue={calculationType}
                                        />
                                    </div>
                                    <div className="col-lg-12 col-sm-12 mb-3">
                                        <label className="s1">Active</label>
                                        <br />
                                        <Switch
                                            checked={values.isActive}
                                            onChange={(checked) => setFieldValue("isActive", checked)}
                                        />
                                    </div>
                                    </>)}
                                </div>
                            }
                            footer={
                                modalMode === "view"
                                    ? null
                                    : [
                                        <div
                                            key="footer"
                                            style={{ display: "flex", justifyContent: "flex-end" }}
                                        >
                                            <button
                                                style={{ marginRight: "20px" }}
                                                className="pdb-save-changes mt-2"
                                                onClick={handleFinalInspection}
                                            >
                                                { modalMode === "edit" ? "Update" : "Submit"}
                                            </button>
                                        </div>,
                                    ]
                            }
                        />

                    </div>
                </div>
            </div>
        </div>
    );
};

export default ListFees;
